module.exports = __webpack_public_path__ + "img/logo.45aa91e0.png";